"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BillingMeetingChargingEnum = void 0;
/** Способ расчёта за митинг */
var BillingMeetingChargingEnum;
(function (BillingMeetingChargingEnum) {
  /** Тип не определён */
  BillingMeetingChargingEnum[BillingMeetingChargingEnum["not_defined"] = -1] = "not_defined";
  /**
   * Free
   * Бесплатно
   */
  BillingMeetingChargingEnum[BillingMeetingChargingEnum["disabled"] = 0] = "disabled";
  /**
   * Оплата митинга по схеме безопасной сделки
   * Занятия оплачиваются участниками по их персональному согласию (accept and pay meeting)
   * Преподаватель получает оплату после проведения занятия
   */
  BillingMeetingChargingEnum[BillingMeetingChargingEnum["fee"] = 1] = "fee";
  /**
   * Оплата митинга в виртуальной валюте "кредиты" с виртуального счёта преподавателя
   */
  BillingMeetingChargingEnum[BillingMeetingChargingEnum["credits"] = 2] = "credits";
  /**
   * Оплата для услуг с повторяющейся серией занятий по схеме безопасной сделки
   * Каждое повторяющееся занятие оплачивается рекарринговыми платежами с банковской карты участников (subscribe service contract)
   * Преподаватель получает оплату после проведения занятия
   */
  BillingMeetingChargingEnum[BillingMeetingChargingEnum["service_recurrent"] = 4] = "service_recurrent";
  /**
   * Оплата для услуг с фиксированной серией занятий по схеме безопасной сделки
   * Занятия оплачиваются одним или несколькими платежами с банковской карты участников сразу за всю серию (signup service contract)
   * Преподаватель получает оплату после проведения занятия
   */
  BillingMeetingChargingEnum[BillingMeetingChargingEnum["service_instant"] = 5] = "service_instant";
})(BillingMeetingChargingEnum = exports.BillingMeetingChargingEnum || (exports.BillingMeetingChargingEnum = {}));
